import icon1 from '../../../Assets/Icons/plugin.svg';
import icon2 from '../../../Assets/Icons/box.svg';
import icon3 from '../../../Assets/Icons/file.svg';


import card1 from '../../../Assets/Cards/whatCard1.webp';
import card2 from '../../../Assets/Cards/whatCard2.webp';
import card3 from '../../../Assets/Cards/whatCard3.webp';
import card4 from '../../../Assets/Cards/whatCard4.webp';

import pcard1 from '../../../Assets/Cards/pcard1.webp';
import pcard2 from '../../../Assets/Cards/pcard2.webp';
import pcard3 from '../../../Assets/Cards/pcard3.webp';
import pcard4 from '../../../Assets/Cards/pcard4.webp';
import pcard5 from '../../../Assets/Cards/pcard5.png';
import pcard6 from '../../../Assets/Cards/pcard6.png';
import pcard7 from '../../../Assets/Cards/pcard7.png';
import pcard8 from '../../../Assets/Cards/pcard8.png';
import pcard9 from '../../../Assets/Cards/pcard9.png';
import pcard10 from '../../../Assets/Cards/pcard10.png';
import pcard11 from '../../../Assets/Cards/pcard11.png';
import pcard12 from '../../../Assets/Cards/pcard12.png';
import {RiDownloadLine} from 'react-icons/ri';

export const productCards = [
    {
        bgImage:pcard1,
        title:"We’ve just launched a layers panel for Handoff!",
        background:"linear-gradient(to right , white,#1e2f7c33)"
    },
    {
        bgImage:pcard2,
        title:"Mixed.io + Hostdesign – Remote collaboration on your prototype designs",
        background:"linear-gradient(to right , white,#d45f5749)"
    },
    {
        bgImage:pcard3,
        title:"How to run remote usability tests using Hostdesign + Zoom or Google Hangouts",
        background:"linear-gradient(to right , white,#76496b38)"
    },
    {
        bgImage:pcard4,
        title:"Launch user tests directly from the Hostdesign iOS app!",
        background:"linear-gradient(to right , white, #94368c67)"
    },

    {
        bgImage:pcard5,
        title:"Organising clients, features, departments and work with folders",
        background:"linear-gradient(to right , white, #8cd1c275)"
    },
    {
        bgImage:pcard6,
        title:"How to create remote usability tests in Hostdesign",
        background:"linear-gradient(to right , white, #eaa6b148)"
    },
    {
        bgImage:pcard7,
        title:"How to organise and share your projects with folders",
        background:"linear-gradient(to right , white,  #F1E9E1)"
    },
    {
        bgImage:pcard8,
        title:"How to pitch and present ideas using prototypes to clients and stakeholders",
        background:"linear-gradient(to right , white, #b8b6bf71)"
    },
    {
        bgImage:pcard9,
        title:"Using goals to determine your best performing prototype",
        background:"linear-gradient(to right , white, #82bcce65)"
    },
    {
        bgImage:pcard10,
        title:"5 great ways to use sections in your Hostdesign projects",
        background:"linear-gradient(to right , white, #b8b6bf71)"
    },
    {
        bgImage:pcard11,
        title:"How to run guerrilla user testing with Hostdesign",
        background:"linear-gradient(to right , white,  #f8bd5e7a)"
    },
    {
        bgImage:pcard12,
        title:"How to run your first design thinking workshop using Hostdesign",
        background:"linear-gradient(to right , white,  #eaa6b148)"
    }
]

export const whatCards = [
    {
        bgImage:card1,
        title:"Getting started with User Testing and the all-new Hostdesign 3",
        sub:"coming soon",
        background:"linear-gradient(to right , white, #82bcce65)"
    },
    {
        bgImage:card2,
        title:"Principles of User Testing at Santander",
        sub:"on demand",
        background:"linear-gradient(to right , white, #eaa6b148)"
    },
    {
        bgImage:card3,
        title:"How to run your first Design Thinking Workshop",
        sub:"on demand",
        background:"linear-gradient(to right , white, #cbd2dc44)"
    },
    {
        bgImage:card4,
        title:"Getting started with User Testing and the all-new Hostdesign 3",
        sub:"on demand",
        background:"linear-gradient(to right , white, #F1E9E1)"
    }
]
export const bitsCards = [
    {
        bgImage:card1,
        title:"Getting started with User Testing and the all-new Hostdesign 3",
        sub:"download",
        background:"linear-gradient(to right , white, #82bcce65)",
        icon:<RiDownloadLine />
    },
    {
        bgImage:card2,
        title:"Principles of User Testing at Santander",
        sub:"download",
        background:"linear-gradient(to right , white, #eaa6b148)",
        icon:<RiDownloadLine />
    },
    {
        bgImage:card3,
        title:"How to run your first Design Thinking Workshop",
        sub:"download",
        background:"linear-gradient(to right , white, #cbd2dc44)",
        icon:<RiDownloadLine />
    },
    {
        bgImage:card4,
        title:"Getting started with User Testing and the all-new Hostdesign 3",
        sub:"download",
        background:"linear-gradient(to right , white, #F1E9E1)",
        icon:<RiDownloadLine />
    }
]
export const features = [
    {
        title:"What' on",
        desc:"Catch up on the latest from the team, from webinars to events",
        icon:icon1
    },
    {
        title:"Product updates",
        desc:"All our launches , news and ship in one place",
        icon:icon2
    },
    {
        title:"Bits and Bob’s",
        desc:"Our collection of online guides and downloadable assets",
        icon:icon3
    }
]